import React from 'react'
import {makeStyles} from '@material-ui/core'
import '../index.css'


import {BrowserRouter as Router} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link';
import Navigation from './Navigation'


function Nav() {
    const useStyles = makeStyles((theme)=>({

        navbar:{
        
            width: '150px',
            height:'100vh',
            backgroundColor: '#F4F4F7',
          position: 'fixed',
          [theme.breakpoints.down('md')]:{
            visibility:'hidden',
          width:'0',
          height:'0'
          }
            
        
        },
        }));
    const classes = useStyles();
    
const location = useLocation();
let current_path = (location.hash.split('#')[1]);


//aaile aba kunai nav ma pani nabalni rakhxu ... if rakhna man vae .. you can do this... for home
// <li className={!current_path||current_path==='home'?classes.activeRoute:classes.listitem}>Home</li>


    return (
        <div className={classes.navbar}>


<Navigation/>
        
               
        </div>
    )
}

export default Nav
